<template>
  <div class="mt-3">
    <div class="row">
      <div class="col">
        <ul v-html="$t('ct-s-checkout-gateway-razorpay-info')" class=""></ul>
      </div>
      <div class="col">
        <!-- Input Description -->
        <div class="form-group">
          <label for="name" class="control-label">{{ $t('ct-name') }}</label>
          <div class="" :class="{'has-error': e.has('name')}">
            <input type="text" class="form-control" @input="e.remove('name')" id="name" name="name"
                   v-model="config.name">
            <span class="label label-danger" v-if="e.has('name')">{{ e.first('name') }}</span>
          </div>
        </div>

        <!-- Input Key_id -->
        <div class="form-group">
          <label for="key_id" class="control-label">{{ $t('ct-cliente-id') }}</label>
          <div class="" :class="{'has-error': e.has('key_id')}">
            <input type="text" class="form-control" id="key_id" name="key_id"
                   @input="e.remove('key_id'), e.remove('keys')" v-model="config.key_id">
            <span class="label label-danger" v-if="e.has('key_id')">{{ e.first('key_id') }}</span>
            <span class="label label-danger" v-if="e.has('keys')">{{ e.first('keys') }}</span>
          </div>
        </div>
        <!-- Input Secret -->
        <div class="form-group">
          <label for="key_secret" class="control-label">{{ $t('ct-secret') }}</label>
          <div :class="{'has-error': e.has('key_secret')}">
            <input type="text" class="form-control" id="key_secret" name="key_secret"
                   @input="e.remove('key_secret'), e.remove('keys')" v-model="config.key_secret">
            <span class="label label-danger" v-if="e.has('key_secret')">{{ e.first('key_secret') }}</span>
            <span class="label label-danger" v-if="e.has('key_secret')">{{ e.first('key_secret') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Form Submit -->
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button class="btn btn-default" @click="$emit('cancel')">{{ $t('ct-cancel') }}</button>
          <button type="button" class="btn btn-info" @click="save">{{ $t('ct-save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RazorpayConfig',
  props: ['value', 'e'],

  data() {
    return {
      config: this.value || {}
    };
  },

  watch: {
    config: {
      handler(config) {
        this.$emit('input', config);
      },
      deep: true
    },
    'value': function(val) {
      this.$emit('input', this.config);
    }
  },

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        name: 'required',
        key_id: 'required',
        key_secret: 'required'
      });

      this.e.validate(this.config);

      if (!this.e.any()) this.$emit('save', this.config);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/GatewayConfig/RazorpayConfig.vue